import jstz from 'jstz';
import { getStrBetweenParens } from './strUtils';
import DateFnsUtils from 'material-ui-pickers/utils/date-fns-utils';
import format  from 'date-fns/format';
// import isSameDay from 'date-fns/isSameDay';
// import isSameHour from 'date-fns/isSameHour';
// import isSameSecond from 'date-fns/isSameSecond';
// import isEmpty from 'lodash/isEmpty';

// Input: Date object
// Output: single digit representing number of hours difference between local timea and utc time.
export function  getDateOffSetInHrs (date)  {
    return date.getTimezoneOffset() / 60;
};

// Input: Date Object
// Output: extracts the full timezone name (eg Eastern Daylight Time)from the toString represenation of the date
export function getDateTimezone (date)  {
     return getStrBetweenParens(date.toString());
};

// Detect timezone using jstz.js library
export function getTimezone() {
    let tz = jstz.determine();
    return tz.name();
}

// Copies the time from one date object to a second date object then returns the toDateObject
export function copyTimePart(fromDateObject, toDateObject) {

    let hours      = fromDateObject.getHours();
    let minutes    = fromDateObject.getMinutes();
    let seconds    = fromDateObject.getSeconds();
    
    toDateObject.setHours(hours);
    toDateObject.setMinutes(minutes);
    toDateObject.setSeconds(seconds);
   
    return toDateObject;
}


// Copies the date from one date object to a second date object then returns the toDateObject
export function copyDatePart(fromDateObject, toDateObject) {
    
    let day      = fromDateObject.getDate();
    let month    = fromDateObject.getMonth();
    let year     = fromDateObject.getFullYear();

    toDateObject.setDate(day);
    toDateObject.setMonth(month);
    toDateObject.setFullYear(year);

    return toDateObject;
}


// WEBPACK FOOTER //
// ./src/utils/dateUtils.js